import { FC } from "react";
import { StyleBody } from "./style";

const TimelineBody: FC = ({ children }) => {
  return <StyleBody>{children}</StyleBody>;
};

export default TimelineBody;
